import {
  createLazyContext,
  useLazyContextProvider,
  useRequiredContext,
} from "@redotech/react-util/context";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { Parcel } from "@redotech/redo-model/outbound-labels/parcel";
import { OrderManagementPermissions } from "@redotech/redo-model/permissions";
import { memo, ReactNode } from "react";
import { RedoOutboundLabelsRpcClientContext } from "../outbound-labels-rpc-client";

export const ParcelContext = createLazyContext<readonly Parcel[]>();
export const ParcelService = memo(function ParcelService({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const client = useRequiredContext(RedoOutboundLabelsRpcClientContext);

  const canViewParcels = useHasPermission(
    OrderManagementPermissions.SCAN_AND_VERIFY,
  );

  const loadState = useLazyContextProvider(async (signal) => {
    if (!canViewParcels) {
      return [];
    }
    const { parcels } = await client.getParcels(null, { signal });
    return parcels;
  });

  return (
    <ParcelContext.internalContext.Provider value={loadState}>
      {children}
    </ParcelContext.internalContext.Provider>
  );
});
